import transactionsTableTemplate from './reactTransactionsTable.html';
import { AccountService } from '../../../services/AccountService';
import { accounts, transactions, TRANSACTION_TYPES, USER_ACC_REACT } from '../../../services/arsweb/RoutingPaths';
import { reactTransactionCols, defaultSortModel } from '../transactions/transactionsDetailColDefs';
import { TRANSACTIONS_TITLE } from '../../../services/arsweb/TableTitles';
import { REPORT_TYPE } from '../../report/ReportModalController';
import {SearchableItemService} from "../../../services/SearchableItemService";
import {ReactTableController} from "../reactTableController";

export const DETAILVIEW = 'app.transaction';
export const TABLEPARAMS = 'transactionTableParams';

/** @ngInject */
export function reactTransactionsTable() {
    return {
        restrict: 'E',
        scope: {
            tableId: '@',
            fractionDigits: '=',
            hideColumns: '=',
            noInitTotal: '=',
            height: '@'
        },
        templateUrl: transactionsTableTemplate,
        controller: ReactTransactionsTableController,
        controllerAs: 'transactionsTableController'
    };
}

/** @ngInject */
export class ReactTransactionsTableController extends ReactTableController {

    constructor($scope, userService, arsMainDependencies) {
        const reportOptions = {options: [ REPORT_TYPE.PDF_TRANSACTION, REPORT_TYPE.CSV_TRANSACTION_REPORT, REPORT_TYPE.XLSX_TRANSACTION_REPORT ]};
        super($scope, userService, arsMainDependencies, "", new AccountService(userService), accounts + transactions,
        TRANSACTIONS_TITLE, TABLEPARAMS, "transactionID", true, reportOptions, defaultSortModel);

        this.isUserReport = false;
        const searchService = new SearchableItemService(userService);
        const accountID = arsMainDependencies.$stateParams.id;
        const transactionTypesPromise = searchService.backendService.postUserData(TRANSACTION_TYPES + accounts, accountID);
        $scope.$on('consolitationcurrency.change', () => this.resetGridSelection());
        this.backendService.service.config.params['id'] = accountID;
        this.backendService.service.config.params.filter = {};
        this.ftsMainDependencies.initCompletedPromise.then(() => this.initGrid(userService, transactionTypesPromise));
    }

    initGrid(userService, transactionTypesPromise) {
        userService.promise.then(()=> {
            // react account columns
            this.colDefs = reactTransactionCols(this.translate, userService.filterFormatter, transactionTypesPromise,
                this.fractionDigits);
            this.initCols();
            // react gridParameters for account table
            const transactionsGridParams = {
                columnDefs: this.colDefs,
                url: this.backendService.service.getServiceUrl(USER_ACC_REACT + transactions)};
            this.reactGridParams = {...this.defaultReactGridParams, ...transactionsGridParams};
        });
    }
}
